<div class="modal-header">
    <h4 class="modal-title fw-bold" jhiTranslate="audit.germplasm-progenitors.title">Progenitors - View history of changes</h4>
    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" (click)="dismiss()">
    </button>
</div>
<div class="modal-body">
    <iframe id="germplasmProgenitorsAuditModalIFrame" width="100%" height="570" frameborder="0"
            [src]="url"></iframe>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-primary" data-bs-dismiss="modal" (click)="dismiss()">
        <span jhiTranslate="ok"></span>
    </button>
</div>



